import { trustItems } from '@/mocks/home';

export default function TrustStrip() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 overflow-hidden rounded-lg border border-background-200 bg-background-100/60 p-6 md:grid-cols-2 md:p-8 lg:grid-cols-4">
          {trustItems.map((item, index) => (
            <div
              key={item.title}
              className={`flex flex-col ${
                index !== 0 ? 'lg:border-l lg:border-background-300 lg:pl-8' : ''
              }`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}